module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO20QueSonIngresosFIjos (51).a085e76.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO20QueSonIngresosFIjos (51).mp4
// module id = 746
// module chunks = 1